import * as Yup from 'yup';
import { defineMessages } from 'react-intl';

export const validateEmail = async ({ options, createError }: Yup.TestContext, email: string) => {
  const context = options.context as any;
  if (context?.useEmailDeliverabilityValidation) {
    const {
      emailValidationBypassList,
      updateEmailValidationErrors,
      emailValidationErrors,
    } = context?.emailValidationContext;

    if (!emailValidationBypassList[email] && context?.isSubmitting) {
      // VALIDATE ON SUBMIT WHEN BYPASS ISN'T ACTIVE FOR EMAIL
      try {
        const { isDeliverable, error } = await context.appActions.validateEmail(email);
        if (!isDeliverable && error) {
          updateEmailValidationErrors(email, error);
          return createError({
            message: error,
          });
        }
      } catch (error) {
        return true;
      }
    } else if (
      !context?.isSubmitting
            && !emailValidationBypassList[email]
            && emailValidationErrors[email]
    ) {
      return createError({
        message: emailValidationErrors[email],
      });
    }
  }
  return true;
};

// BE email uses FILTER_SANITIZE_EMAI before email validation and uses FILTER_VALIDATE_EMAIL
// this will remove these characters and fail validation so we are stopping their usage in the
// emails on the FE to stay consistent and not confuse users
// https://www.php.net/manual/en/filter.filters.sanitize.php

/* eslint-disable */
export const asciiRegex = /^[a-zA-Z0-9!#$%&'*+\-=?^_`{|}~@.\[\]]+$/;

export const asciiMessage = defineMessages({
  noAscci: {
    id: '',
    defaultMessage: 'Email contains invalid characters',
    description: 'Message if email contains non ascii & illegal characters',
  },
});
